import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-jobtitles',
  templateUrl: './admin-jobtitles.component.html',
  styleUrls: ['./admin-jobtitles.component.css']
})
export class AdminJobtitlesComponent implements OnInit{
  businesses: any = [];
  authToken = localStorage.getItem('auth');
  isLoading = false;
  selectedBusiness: any;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.fetchJobTitles();
  }

  fetchJobTitles() {
    
  }
}
